import { api } from '@/lib/api-manager'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'

export async function getAllCoursesByCurriculum(curriculum?: string) {
  const result = (
    await api.get('v1/educations/integrations/curriculums/courses', {
      params: { curriculum }
    })
  ).data

  const courses: DesiredEducationCourse[] = result.data.map((course: any) => {
    const mapped: DesiredEducationCourse = {
      id: '',
      courseId: course.id,
      name: course.name,
      period: course.period,
      serie: course.serie,
      workload: course.workload,
      description: course.description
    }

    return mapped
  })

  return courses
}
